import React from "react";
import icon from "../../../assets/vp-buisness-detail-icon.png";

function VPBusinessDetails({ userInfo }) {
  return (
    <div className="vp-supplier-type mb-3">
      <div className="card">
        <div className="card-header">
          <div className="d-flex align-items-center">
            <img width={22} height={22} src={icon} alt="icon" />
            <h5 className="m-0 ms-2 vp-supplier-type-title">
              Business details
            </h5>
          </div>
        </div>
        <div className="card-body">
          <div className="d-flex flex-column w-100 gap-2">
            <div className="d-flex align-items-center justify-content-between">
              <p className="m-0 p-0 vp-pd-list-item-text-1">
                Where does your experience take place?
              </p>
              <p className="m-0 p-0 vp-pd-list-item-text-2">
                {userInfo?.data?.supplier?.registered_country?.name}
              </p>
            </div>
            <div className="d-flex flex-column align-items-start justify-content-between">
              <p className="m-0 p-0 vp-pd-list-item-text-1">
                Tell us about yourself
              </p>
              <p
                className="m-0 p-0 vp-pd-list-item-text-2"
                dangerouslySetInnerHTML={{
                  __html: userInfo?.data?.supplier?.company_overview,
                }}
              ></p>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <p className="m-0 p-0 vp-pd-list-item-text-1">Public name</p>
              <p className="m-0 p-0 vp-pd-list-item-text-2">
                {userInfo?.data?.supplier?.supplier_public_name}
              </p>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <p className="m-0 p-0 vp-pd-list-item-text-1">Legal name</p>
              <p className="m-0 p-0 vp-pd-list-item-text-2">
                {userInfo?.data?.supplier?.supplier_legal_name}
              </p>
            </div>

            <div className="d-flex align-items-center justify-content-between">
              <p className="m-0 p-0 vp-pd-list-item-text-1">Phone number</p>
              <p className="m-0 p-0 vp-pd-list-item-text-2">
                {userInfo?.data?.supplier?.supplier_phone_number}
              </p>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <p className="m-0 p-0 vp-pd-list-item-text-1">Website</p>
              <p className="m-0 p-0 vp-pd-list-item-text-2">
                {userInfo?.data?.supplier?.supplier_website}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VPBusinessDetails;
